import React from 'react';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Carlos M.',
  age: '34 años',
  location: 'Buenos Aires',
  text: 'Tenía miedo de no entender nada de tecnología, pero este sistema es tan simple que lo pude seguir desde mi celular. Ya generé mis primeros ingresos y por fin respiro tranquilo.'
}, {
  name: 'Laura R.',
  age: '29 años',
  location: 'Córdoba',
  text: 'Siempre llegaba justo a fin de mes. Con esta guía aprendí a usar la IA para crear contenido rápido y venderlo. Es increíble lo fácil que es cuando te explican el paso a paso.'
}, {
  name: 'Miguel A.',
  age: '42 años',
  location: 'Rosario',
  text: 'Pensé que la IA era solo para programadores. Este libro me abrió los ojos. Ahora uso herramientas gratuitas para hacer trabajos en minutos que antes me tomaban horas.'
}, {
  name: 'Sofía V.',
  age: '28 años',
  location: 'Mendoza',
  text: 'Lo mejor es que no tuve que invertir nada extra. Solo seguí los pasos, usé las herramientas gratuitas que recomiendan y empecé a ver resultados en la primera semana.'
}, {
  name: 'Diego F.',
  age: '37 años',
  location: 'Mar del Plata',
  text: "Estaba escéptico, pero el precio era accesible así que probé. La sección de 'errores comunes' me salvó de perder tiempo. Muy recomendado para empezar de cero."
}];
export function TestimonialSection() {
  return <section className="py-16 px-4 relative overflow-hidden" data-id="element-290">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-100 via-green-50 to-slate-50" data-id="element-291" />
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diagmonds-light.png')] opacity-40" data-id="element-292" />
      <div className="absolute top-0 left-0 w-96 h-96 bg-green-200/20 rounded-full blur-3xl" data-id="element-293" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-200/10 rounded-full blur-3xl" data-id="element-294" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-295">
        <h2 className="font-display text-5xl md:text-6xl font-bold text-center text-slate-900 mb-12 tracking-wide" data-id="element-296">
          PERSONAS REALES OBTENIENDO{' '}
          <span className="text-green-600" data-id="element-297">RESULTADOS REALES</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-298">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white/80 backdrop-blur-sm border-2 border-slate-200 p-6 rounded-xl shadow-lg hover:border-green-500/50 hover:shadow-xl transition-all" data-id="element-299">
              <div className="flex gap-1 mb-4" data-id="element-300">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-301" />)}
              </div>
              <p className="text-slate-700 mb-6 italic text-center" data-id="element-302">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 justify-center" data-id="element-303">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-500 to-blue-600 flex items-center justify-center text-white font-bold shadow-md" data-id="element-304">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-305">
                  <p className="font-bold text-slate-900" data-id="element-306">{t.name}</p>
                  <p className="text-xs text-slate-600" data-id="element-307">
                    {t.age} • {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}